import { render } from "./PartnerRenewActionCard.vue?vue&type=template&id=b7333ffc"
import script from "./PartnerRenewActionCard.vue?vue&type=script&lang=js"
export * from "./PartnerRenewActionCard.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__